export default {
  "7e114ac94166f7e763dcb44d63aa8e1a": "Order placement page",
  "b5fe836a6d3fbbc5e95129cead17d40e": "The subject expansion component has been exposed",
  "c2af4fcf5b90cb9f179e3cdce608a2ee": "Mall order confirmation page - Coupon retention pop-up window - Confirmation button",
  "57950bd46fa47fb8fcea3b20c1c288fb": "Accept and use",
  "bcbd6b44312685a43800b922f199df8a": "Failed to claim",
  "f644fb9a4519355a8da1f64fc94edb66": "This product is temporarily unavailable for purchase. Please contact customer service",
  "8ce562997645526239623f8f72931c3c": "No address selected",
  "19468132a5f1e5c21f8b70574a6ba49f": "No payment method was selected",
  "cad27f9072af037e76552b1bb37a4f3c": "Confirm order checkout counter - Click the \"Pay Now\" button",
  "890ca4dbf6dcad1eac1ae40d607f73e3": "Coupon ID",
  "efcbc88e75d142089eede97f8289b645": "; Voucher ID",
  "281253962349ff8082ff1027931ef76b": "; Total price",
  "f05994bf4fe507e9d499dc42fccec46e": "\"Mall Order confirmation page - Bottom button.",
  "7c80332494d33b2f1f87a723cac1707f": "Click on the coupon on the mall order confirmation page",
  "321ae2d2073ac59fe31b3f509bbdd216": "Has been taken off the shelves",
  "b202d974ceeb3ede24e96c1fa17e93ac": "Sold out",
  "a69f3d24912fea7a6ef769b797449edb": "Insufficient growth beans",
  "9342234c70c7ff04efb8d1dd341413ac": "Exchange now",
  "3e0cf6cf25dfa2f8d13908dcffbd300b": "\"Pay immediately",
  "23b9a391df9da79cd38db19850f855cb": "Parameter error!",
  "12836810affe0aa90138d03ae352abcc": "Payment in progress...",
  "8a81f31b60bcf273bb047297ea3f1dcd": "Product details",
  "157d7443e1302a3f587cfa43f81efd0a": "Price details",
  "4928e9df06efbb05832f40151a973615": "Payment method",
  "44d98997d8ccb61062c3425a262b4add": "If there are no quality issues with the items exchanged for growth beans, returns and exchanges are not supported",
  "008c885d00e7761df2e800e58558ff2c": "The retention pop-up window on the product detail page has been exposed",
  "3049a87611b81d01f2521faa8a90b239": "\"Mall\"",
  "78c923976c120f18344800b3e37eb85c": "Click the button to retain the pop-up window content on the product detail page",
  "87c126344a8907ba094a10364e87813e": "Others",
  "9d8aaf677170687608ead4dca1058592": "Click the button at the bottom of the retention pop-up window on the product detail page",
  "25faa1bbd1c61e39fbaee2ea6c799012": "Give up"
}
